import React, { useEffect, useState } from 'react';

import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardTitle,
	IonContent,
	IonLoading,
	IonList,
	IonButton,
	IonItem,
	IonInput,
	IonLabel
} from '@ionic/react';

import { OrderHelperActivateResults } from '../../store';
import { useHistory } from 'react-router';
import { useToast } from '@agney/ir-toast';
import { useCtx } from '../../../config/hooks';

const AccessOrderView: React.FC<any> = viewProps => {
	// UI State
	const [showInstructions, setShowInstructions] = useState(false);
	const [initialized, setInitialized] = useState(false);

	// Form code
	const [orderId, setOrderId] = useState('');
	const [contextId, setContextId] = useState('');
	const [goActivate, setGoActivate] = useState(false);
	const [activating, setActivating] = useState(false);
	const [activationStatus, setActivationStatus] = useState('');

	// Hook ins
	const history = useHistory();
	const Toast = useToast();
	const ctx = useCtx<{}>({});

	const activateOrderButtonClicked = (e: any) => {
		setGoActivate(true);
		setActivationStatus('Working...');
	};

	useEffect(() => {
		init();
		if (!activating && goActivate) {
			setGoActivate(false);
			activate();
		}
	}, [goActivate]);

	const init = async () => {
		// Initialize only once
		if (!initialized) {
			let qsContextId = viewProps.match?.params?.contextId ?? '';
			let qsOrderId = viewProps.match?.params?.orderId ?? '';

			if (typeof qsContextId === 'string') {
				setContextId(qsContextId);
			}
			if (typeof qsOrderId === 'string') {
				setOrderId(qsOrderId);
				if (qsOrderId !== '') setGoActivate(true);
			}

			setInitialized(true);

			if (qsOrderId == '' || qsContextId == '') {
				history.push(`/main`);
			}
		}
	};

	const onError = (message: string) => {
		Toast.error(message);
		setActivating(false);
	};

	const onSuccess = (result: OrderHelperActivateResults) => {
		ctx.lead.order.set(result.order.id);
		ctx.lead.context.set(result.context.id);
		ctx.lead.event.set(result.context.eventIds[0]);
		ctx.lead.service.set(result.service.id);

		setTimeout(() => {
			ctx.lead.user.readActiveData(ctx, () => {
				Toast.success('Order successfully activated!');
				setActivationStatus('Order activated successfully!');
				setActivating(false);
				setOrderId('');

				// Set the active context, event, and service
				ctx.lead.context.set(result.context.id);
				ctx.lead.event.set(result.context.eventIds[0]);
				ctx.lead.service.set(result.service.id);

				if (
					!result.context.id ||
					!result.context.eventIds[0] ||
					!result.service.id
				) {
					history.push(`/main`);
				} else {
					history.push(`/lead-service/event`);
				}
			});
		}, 5000);
	};

	const activate = async () => {
		setActivating(true);
		setActivationStatus('Loading order...');
		ctx.lead.order.activateNew(ctx, orderId, contextId, onError, onSuccess);
	};

	return (
		<IonContent>
			<IonCard className="conexsys-card">
				<IonCardContent>
					<p hidden={!showInstructions} className="instructions">
						Please enter your Order ID to activate your order. Ensure you have
						the correct Order ID before proceeding.
					</p>
					{!activating ? (
						<IonList lines="none">
							<IonItem>
								<IonLabel position="stacked">Order ID</IonLabel>
								<IonInput
									placeholder="Enter your Order ID"
									name="orderId"
									className="required"
									value={orderId}
									onIonChange={(e: any) => setOrderId(e?.target?.value || '')}
								></IonInput>
							</IonItem>
							<IonButton
								color="light"
								expand="full"
								disabled={orderId === ''}
								onClick={activateOrderButtonClicked}
								className="activate-button"
							>
								Activate Order
							</IonButton>
						</IonList>
					) : (
						<>
							<IonList lines="none">
								<IonItem>
									<IonLabel>
										<h2>Retrieving Your Order</h2>
										<p>
											Order ID: <strong>{orderId}</strong>
										</p>
										<p>Please wait while we process your request...</p>
									</IonLabel>
								</IonItem>
							</IonList>
							<IonLoading
								isOpen={true}
								message={`<h2>Retrieving Your Order</h2><p>${activationStatus}</p>`}
								duration={50000}
							/>
						</>
					)}
				</IonCardContent>
			</IonCard>
		</IonContent>
	);
};

export default AccessOrderView;
